import axios from "axios";

import React, { useState, useEffect } from "react";
import "./ContactUs.css";
import UseForm from '../NewsLetter/UseForm';
import Modal from '../Modal/Modal';
import dataServices from "../../common/dataServices";

const ContactUs =(props) =>{
    const errorStyle = {
        color: 'red'
        ,fontSize: '14px'
      ,fontFamily:'Roboto'      
      };

  const [choicesObj, setChoicesObj] =useState({});
  const [showModal,setShowModal] = useState(false);
  const [isSucc,setIsSucc] = useState(null);
  const [companyChoicesOpt, setCompanyChoicesOpt] =useState([]);
  const [firstName,setFirstName]= useState('');
  useEffect(()=>{
   
    if(isSucc!=null){
      setShowModal(true);
    }
    
  },[isSucc]);
  useEffect(()=>{

    GetCategoryForContactUs();
      //console.log(props.subject);
  },[]);
  const GetCategoryForContactUs=()=>{
      dataServices
      .getSPListItems(props.mainURL, 'ContentPages', 'ContactUsCategoryChoices')
      .then((response) => {return response.data})
      .then((lsItemsResponse) => {
        try {
        
           let tempCompanyChoicesOpt =  lsItemsResponse.Data.map((choice,idx)=>{
               let tempChoice = choice.ContainerTitle;
               return   <option value={tempChoice} key={idx}>{tempChoice}</option>
       });
       setCompanyChoicesOpt(tempCompanyChoicesOpt);
       
          if(!!props.subject){
               ChangeMashanContactUsChoice();
             }
        } catch (e) {
          console.log(e);
        }
      });
      
  };
    const constNewsLetterObj={ Fields:{
        Title: {value: 'Contact us form' ,error:''}
        ,MashanContent: { value: '',error:'' }
        ,MashanPhoneNumber: { value: '',error:'' }
        ,MashanContactUsChoice: { value: props.subject, error:''}
        ,MashanFirstName: { value: '', error:''}
        ,MashanLastName: { value: '', error:''}
        ,MashanEmail: { value: '', error:''}
        
    },
    MailTo:'',
    //the key in webconfig
    type: 1
    , webUrl: props.mainURL
    };
    let validationStateSchema = {
        Title: { },
        MashanContactUsChoice:{
          required: false
        },
        MashanContent:{
          required: false
        },
        MashanFirstName: {
          required: true,
          validator: {
            regEx:/^[a-zA-Z\u0590-\u05ff]+?[a-zA-Z\u0590-\u05ff_ ]+$/,
            error: 'Invalid first name format.',
          },
        },
        MashanLastName: {
            required: true,
            validator: {
              regEx:/^[a-zA-Z\u0590-\u05ff]+?[a-zA-Z\u0590-\u05ff_ ]+$/,
              error: 'Invalid last name format.',
            },
          },
          MashanPhoneNumber: {
          required: true,
        //   validator: {
        //     regEx:/^[0-9]+? $/,
        //     error: 'Only numbers allowed',
        //   }
         },
        MashanEmail: {    
          required: true,
            validator: {
              regEx:  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              error: 'Invalid mail format.',
            },
          },
    
      };
      const ChangeMashanContactUsChoice=()=>{
        const $select = document.querySelector('#MashanContactUsChoice');
        $select.value =  props.subject;
      };
      useEffect(()=>{
        if(!!props.subject){
          ChangeMashanContactUsChoice();
           
        }
      },[props.subject]);

      const onSubmitForm=(state)=>{
        let tempState = {...constNewsLetterObj};
          let tempSelectedChoices=[];
          Object.keys(choicesObj).map((sortedItems,index)=>{
              choicesObj[sortedItems].map((item,idx)=>{
                  if(item.checked){
                    return  tempSelectedChoices.push(item.fullText);
                  }
              });
          });

          setFirstName(state.Fields["MashanFirstName"].value);
          
            dataServices.setItems(state).then(response=>{
              setIsSucc(true);
            })
            .catch((error)=>
            {
               setIsSucc(false);
            });
      };
      const handleOnClose= ()=>{
       
        setShowModal(false);
        setIsSucc(null);
      }
        
    const { state, handleOnChange, handleOnSubmit, disable } = UseForm(constNewsLetterObj,validationStateSchema,onSubmitForm  );
  
    return (<div className="container-contactus-wrapper col-12 col-md-9 nav-section" id={`nav-section-0`}>
    
     <Modal show={showModal} isSucc={isSucc} data={firstName} onClose={handleOnClose}/>
      
        <h2  role='heading' className="contactus-title">{props.title}</h2>
       
        {props.showNote &&   <div className="col-12 col-md-12 row">
                              <div className="col-12 col-md-12">
    <div className="contactus-note  col-12 col-md-12" >
            <div className="info-icons col-2 col-md-1"></div>
          <div className="contactus-info-note col-10 col-md-12">
                <h3 role='heading' className="contactus-note-title">Please note</h3>
                <h3 role='heading' className="contactus-note-text col-md-11">{props.freeText}</h3>
            </div>
    </div></div></div>}
  
    <div className="container-newsletter-wrapper " >
    <fieldset legend='contact us form' role="contact us group" >
              <form              role="form"
                   onSubmit={handleOnSubmit}   
              >
              <div className="container-newsletter-wrapper-child col-12 col-md-12">
              {/* <div className="newslettertitle-input-warpper  col-12 col-md-12 row"> */}
              <div className="contactuspage-title-input-warpper  col-12 col-md-12 row">
                  <div className="newsletter-form-field newsletter-checkbox-title col-12 col-md-6">
                            <label className="col-12 col-md-12"
                             //htmlFor={'first-name-news-letter'}
                             htmlFor={'MashanFirstName'}
                             >FIRST NAME</label>
                            <input
                             type='text'
                             onChange={handleOnChange} 
                             value={state.Fields["MashanFirstName"].value}
                             name='MashanFirstName'
                             className={"col-12 col-md-12 " && state.Fields["MashanFirstName"].error && 'error-border'} 
                              id={'MashanFirstName'}  placeholder="Required Field"
                              aria-invalid={state.Fields["MashanFirstName"].error  ? 'true':'false'}
                              
                              aria-required={true}
                              />
                            {state.Fields["MashanFirstName"].error && <p style={errorStyle} className="error-message">{state.Fields["MashanFirstName"].error}</p>}
                        
                  </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12 col-md-6">
                                    <label className="col-12 col-md-12" htmlFor={'MashanLastName'}>LAST NAME</label>
                                    <input 
                                    className={"col-12 col-md-12 " && state.Fields["MashanLastName"].error && 'error-border'}
                                      type='text'  id={'MashanLastName'} 
                                    placeholder="Required Field" 
                                    value={state.Fields["MashanLastName"].value}
                                    onChange={handleOnChange}  name='MashanLastName'
                                    aria-invalid={state.Fields["MashanLastName"].error  ? 'true':'false'}
                                    required
                                    aria-required={true}
                                    aria-describedby={"error_contactus_id"}
                                    />
                                    {state.Fields["MashanLastName"].error && <p style={errorStyle} id={"error_contactus_id"} className="error-message">{state.Fields["MashanLastName"].error}</p>}
                                                            </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12 col-md-6">                           
                                    <label className="col-12 col-md-12" htmlFor={'MashanEmail'}>MAIL</label>
                                    <input 
                                      className={"col-12 col-md-12 "  && state.Fields["MashanEmail"].error && 'error-border'} 
                                     type='text'  id={'MashanEmail'} placeholder="Required Field"
                                    onChange={handleOnChange}  name='MashanEmail'
                                    value={state.Fields["MashanEmail"].value}
                                    aria-invalid={state.Fields["MashanEmail"].error  ? 'true':'false'}
                                    required
                              aria-required={true}
                              aria-describedby={"error_contactus_mashanemail"}
                                    />

                                    {state.Fields["MashanEmail"].error && <p style={errorStyle} id={"error_contactus_mashanemail"} className="error-message">{state.Fields["MashanEmail"].error}</p>}                        </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12 col-md-6">
                                    <label className="col-12 col-md-12" htmlFor={'MashanPhoneNumber'}>PHONE</label>
                                    <input 
                                    className={"col-12 col-md-12 "  && state.Fields["MashanPhoneNumber"].error && 'error-border'} 
                                    type='text'  id={'MashanPhoneNumber'}  placeholder="Required Field"
                                    onChange={handleOnChange}  name='MashanPhoneNumber'
                                    value={state.Fields["MashanPhoneNumber"].value}
                                    aria-invalid={state.Fields["MashanPhoneNumber"].error  ? 'true':'false'}
                                    required
                              aria-required={true}
                              aria-describedby={"error_contactus_mashanphone"}
                                    />
                                    {state.Fields["MashanPhoneNumber"].error && <p style={errorStyle}
                                        id={'error_contactus_mashanphone'}
                                    className="error-message">{state.Fields["MashanPhoneNumber"].error}</p>}
                        </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12 col-md-6">
                                    <label className="col-12 col-md-12" htmlFor={'MashanContactUsChoice'}>SUBJECT</label>
                                    <select className="col-12 col-md-12" id={'MashanContactUsChoice'} 
                                            onChange={handleOnChange}
                                            name='MashanContactUsChoice'
                                            value={state.Fields["MashanContactUsChoice"].value}
                                            aria-invalid={state.Fields["MashanContactUsChoice"].error  ? 'true':'false'}
                                            id='MashanContactUsChoice'
                                            
                              aria-required={false}
                              
                                            >
                                        <option value="" disabled  hidden  >Select</option>   
                                        {companyChoicesOpt}
                                    </select>
                        </div>
                        <div className="newsletter-form-field newsletter-checkbox-title col-12 col-md-12">
                                    <label className="col-12 col-md-12" htmlFor={'MashanContent'}>MESSAGE</label>
                                    <input className="col-12 col-md-12"  type='text'  id={'MashanContent'} 
                                    placeholder="Message" 
                                    value={state.Fields["MashanContent"].value}
                                    aria-invalid={state.Fields["MashanContent"].error  ? 'true':'false'}
                                    onChange={handleOnChange}
                                      name='MashanContent'
                                      aria-required={false}
                                    />
                                      </div>
                  </div>
                    <button  className='btn btn-primary newsletter-btn' type="submit" name="submit">SEND MESSAGE</button>
                         </div>
                    </form> 
              </fieldset>
          </div>
    </div>);
}

export default ContactUs;